import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '@clerk/clerk-react';
import { Check, Crown } from 'lucide-react';
import usePiano from '../hooks/usePiano';
import '../components/ConfirmModal.css';

// Pagina pubblica dei piani: VETRINA. Mostra Free e Pro affiancati. I CTA sono
// condizionali in base allo stato di login:
//  - anonimo            -> registrazione (acquisizione)
//  - loggato, non Pro   -> dashboard con la scelta piano gia' aperta (?plan=open),
//                          dove avviene il checkout legato all'account
//  - loggato, gia' Pro  -> "Sei gia' Pro"
function Piani() {
  const { isSignedIn } = useAuth();
  const { isPro } = usePiano();

  // Destinazione del CTA Pro a seconda dello stato.
  const proTo = !isSignedIn ? '/registrazione' : '/dashboard?plan=open';

  return (
    <div className="admin-page" style={{ maxWidth: 820 }}>
      <h1>I nostri piani</h1>
      <p style={{ color: '#777', marginBottom: '2rem' }}>
        Inizia gratis e passa a Pro quando vuoi per sbloccare tutto. Puoi disdire in qualsiasi momento.
      </p>

      <div className="plan-options" style={{ alignItems: 'stretch' }}>
        {/* FREE */}
        <div className="plan-option" style={{ cursor: 'default' }}>
          <span className="plan-price">€0<span>/sempre</span></span>
          <span className="plan-sub">Free</span>
          <ul style={listStyle}>
            <li><Check size={15} /> 1 scheda servizio</li>
            <li><Check size={15} /> 1 foto per scheda</li>
            <li><Check size={15} /> Profilo pubblico</li>
          </ul>
          {isSignedIn ? (
            <Link to="/dashboard" className="home-btn home-btn-light" style={{ marginTop: 'auto' }}>
              Vai alla dashboard
            </Link>
          ) : (
            <Link to="/registrazione" className="home-btn home-btn-light" style={{ marginTop: 'auto' }}>
              Inizia gratis
            </Link>
          )}
        </div>

        {/* PRO */}
        <div className="plan-option featured" style={{ cursor: 'default' }}>
          <span className="plan-badge"><Crown size={13} style={{ verticalAlign: '-2px' }} /> Pro</span>
          <span className="plan-price">€15<span>/mese</span></span>
          <span className="plan-sub">oppure €150/anno · 2 mesi gratis</span>
          <ul style={listStyle}>
            <li><Check size={15} /> Schede e foto illimitate</li>
            <li><Check size={15} /> Gestione del listino prezzi</li>
            <li><Check size={15} /> Leggi e rispondi ai messaggi</li>
          </ul>
          {isPro ? (
            <span className="plan-sub" style={{ marginTop: 'auto', color: 'var(--primary, #b5270a)' }}>
              Sei già Pro ✓
            </span>
          ) : (
            <Link to={proTo} className="home-btn" style={{ marginTop: 'auto' }}>
              Passa a Pro
            </Link>
          )}
        </div>
      </div>

      <p style={{ marginTop: '2rem' }}>
        <Link to="/" className="home-btn home-btn-light">Torna alla home</Link>
      </p>
    </div>
  );
}

const listStyle = {
  listStyle: 'none',
  padding: 0,
  margin: '0.75rem 0',
  textAlign: 'left',
  fontSize: '0.9rem',
  display: 'flex',
  flexDirection: 'column',
  gap: '0.4rem',
  color: 'var(--on-surface-variant, #5a403b)',
};

export default Piani;
